export function debounce(fn, wait) {
    let timeout;
    
    const debounced = function(...args) {
      const later = () => {
        timeout = null;
        fn.apply(this, args);
      };
      
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
    
    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = null;
    };
    
    return debounced;
}